import request from '@/utils/request';

// 上传生成文件
export function syncCreateXmlFileApi(data) {
  return request({
    baseURL: '/steward/web',
    url: '/fastDfs/uploadFileContent',
    method: 'post',
    data
  });
}
// 用户删除自定义模板
export function delUserCustomPrintTplApi(data, loginId) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/delBatchModel?loginId=' + loginId,
    method: 'post',
    data
  });
}
// 删除FASTDFS文件
export function syncDeleteXmlFileApi(data) {
  return request({
    baseURL: '/steward/web',
    url: '/fastDfs/deleteFile',
    method: 'post',
    data
  });
}
// 修改模板时，保存该模板是否选中圆准达服务
export function setYzdServiceApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/setService',
    method: 'post',
    data
  })
}
// 用户修改自定义模板
export function changeCustomerUserTempApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/changeUserTemp',
    method: 'post',
    data
  });
}
// 新增弹层中模板下拉框数据
export function getUserCustomPrintTplApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/getBasePrintTemp',
    method: 'post',
    data
  });
}
// 设置默认面单来源
export function setDefautPrintAccountApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/setUserDefautPrintAccount',
    method: 'post',
    data
  });
}
// 用户自定义模板保存
export function saveUserCustomerPrintTempApi(data, loginId) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/saveUserPrintTemp?loginId=' + loginId,
    method: 'post',
    data
  });
}
// 抖音厂商代发电子面单授权接口
export function dydfMallCodeWayBillApi(data) {
  return request({
    url: '/ecom/dydf/mallCodeWayBill',
    method: 'post',
    data
  });
}
// 批量获取电子面单账号信息接口
export function batchExpressBindApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/batchExpressBind',
    method: 'post',
    data
  });
}
// 校验当前模板是否开启圆准达服务
export function valilYzdServiceApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/selectWaybillService',
    method: 'post',
    data
  });
}
// 顺丰、邮政快递包裹、ems 修改客户编号接口
export function updateSettlementCodeApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/basicEcom/updateSettlementCode',
    method: 'post',
    data
  });
}
// 对模板设置默认店铺的店铺列表
export function queryTempMallApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/queryTempMall',
    method: 'post',
    data
  });
}
// 给模板设置默认店铺保存操作
export function editTempMallApi(data) {
  return request({
    baseURL: '/webApi/',
    url: '/CustomerPrintTemp/editTempMall',
    method: 'post',
    data
  })
}
